var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDeactivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3192 8.68125L8.68082 13.3196C8.08499 12.7237 7.71832 11.9079 7.71832 11.0004C7.71832 9.18542 9.18499 7.71875 11 7.71875C11.9075 7.71875 12.7233 8.08542 13.3192 8.68125Z",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.335 5.28895C14.7308 4.07895 12.8975 3.41895 11 3.41895C7.76415 3.41895 4.74831 5.32561 2.64915 8.62561C1.82415 9.91811 1.82415 12.0906 2.64915 13.3831C3.37331 14.5198 4.21665 15.5006 5.13331 16.2889",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71832 17.9029C8.76332 18.3429 9.87249 18.5812 11 18.5812C14.2358 18.5812 17.2517 16.6745 19.3508 13.3745C20.1758 12.082 20.1758 9.90953 19.3508 8.61703C19.0483 8.14036 18.7183 7.6912 18.3792 7.26953",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2175 11.6416C13.9792 12.9341 12.925 13.9883 11.6325 14.2266",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68081 13.3193L1.83331 20.1668",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 1.83301L13.3192 8.68051",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDeactivate);
export default __webpack_public_path__ + "static/media/menu-deactivate.6d54035a4ecc06d64d5885206c6fa0af.svg";
export { ForwardRef as ReactComponent };